import React from "react";
import { Grid, Typography } from "@material-ui/core/";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  "@global": {
    "html, body": {
      margin: 0,
      padding: 0
    }
  },
  root: {
    minHeight: 80,
    backgroundColor: "#fff"
  },
  title: {
    fontSize: "35px"
  },
  "@media screen and (max-width : 767px)": {
    title: {
      fontSize: "26px"
    }
  }
});

export default function TitlePage({ label }) {
  const classes = useStyles();
  return (
    <Grid
      container
      item
      justify="center"
      alignItems="center"
      className={classes.root}
    >
      <Typography component="h1" className={classes.title}>
        {label}
      </Typography>
    </Grid>
  );
}
